import type {
  CreateAccountDeletionRequestInput,
  UserAccountDeletionRequestSummary,
} from '@tabbio/types';
import { api } from './api';

export async function requestAccountDeletion(
  input: CreateAccountDeletionRequestInput,
): Promise<UserAccountDeletionRequestSummary> {
  const res = await api.post<UserAccountDeletionRequestSummary>(
    '/api/account-deletion/request',
    input,
  );

  if (res.error || !res.data) {
    throw new Error(res.error?.message ?? 'Could not delete account');
  }

  return res.data;
}
